import { supabase } from './api'

export const revalidate = 0

function getCompanyId() {
  return localStorage.getItem("companyId");
}


export async function getAllType() {
  const companyId = getCompanyId();
  const { data, error } = await supabase.from('parameterstype').select().eq('companyId',companyId);

  if (error) {
    throw new Error('Failed to fetch data')
  }

  return data;
}

export async function getAllData() {
  const companyId = getCompanyId();
    const { data, error } = await supabase.from('parameters').select().eq('companyId',companyId)
    .neq('type','DESIRED_COLLEGES').neq('type','SCHOOL');

    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }


  export async function getDataWithType(type) {
    const companyId = getCompanyId();
    const { data, error } = await supabase.from('parameters').select()
    .eq('type',type).eq('companyId',companyId)
    .order('order', { ascending: true });

    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function getDataWithTypeForSelect(type) {
    const companyId = getCompanyId();
    const { data, error } = await supabase.from('parameters').select().eq('type',type)
    .eq('isActive',true).eq('companyId',companyId)
    .order('order', { ascending: true });

    if (error) {
      throw new Error('Failed to fetch data')
    }

    const selectData = [];
    data.map(function (cat) {
      selectData.push({ label: cat.pname, value: cat.id })
    })

    //console.log("data",data);

    return selectData;
  }

  export async function getIdData(id) {
    const companyId = getCompanyId();
    const { data, error } = await supabase.from('parameters').select()
    .eq('companyId',companyId)
    .eq('id', id);
    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function addData(adata) {
    const companyId = getCompanyId();
    adata = { ...adata, companyId: companyId};

    const { data, error } = await supabase.from('parameters').insert(adata).select();

    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function updateData(udata) {
    console.log("udata",udata);
    const { data, error } = await supabase.from('parameters').update(udata).eq('id', udata.id).select();

    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function deleteIdData(id) {
    const { data, error } = await supabase.from('parameters').delete()
    .eq('id', id);
    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }


  export async function getDataByPname (pname) {
    const { data, error } = await supabase.from('parameters').select()
    .eq('pname', pname);

    if (error) {
      throw new Error(
        `Failed to fetch progresscheck data by type. Error: ${error.message}`
      );
    }

    return data;
  }
/*

const { error } = await supabase
  .from('parameters')
  .delete()
  .eq('some_column', 'someValue')


const { data, error } = await supabase
  .from('parameters')
  .update({ other_column: 'otherValue' })
  .eq('some_column', 'someValue')
  .select()

  const { data, error } = await supabase
  .from('parameters')
  .insert([
    { some_column: 'someValue', other_column: 'otherValue' },
  ])
  .select()
  */
